<template>
  <BreadCrumb PageTitle="Mutation de contrat" />
  <MutationContrat />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import MutationContrat from "../../components/Contrat/MutationContrat.vue";

export default defineComponent({
  name: "MutationContratPage",
  components: {
    BreadCrumb,
    MutationContrat,
  },
});
</script>

